import { render, staticRenderFns } from "./ServiceContractProducts.vue?vue&type=template&id=40cf1467&scoped=true"
import script from "./ServiceContractProducts.vue?vue&type=script&lang=js"
export * from "./ServiceContractProducts.vue?vue&type=script&lang=js"
import style0 from "./ServiceContractProducts.vue?vue&type=style&index=0&id=40cf1467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf1467",
  null
  
)

export default component.exports